<template>
    <div class="m-extend-list">
        <RightSideMsg>
            <em>工具作者交流群</em> :
            <strong @click="onQQClick" class="u-link" title="点击复制">
                <a>{{ qq }}</a>
            </strong>
        </RightSideMsg>
        <minirank />
        <!-- 其他链接 -->
        <div class="m-jx3dat-links m-side-links">
            <h3 class="m-side-title" style="border-bottom: none">
                <div class="u-title">
                    <svg height="512" viewBox="0 0 50 50" width="512" xmlns="http://www.w3.org/2000/svg" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M2.2 15.928L26.382 1.875l-1.155-.666L1.046 15.26z" fill="#fe91ab"/><path d="M28.264 22.88c-1.066-.616-1.93-2.114-1.926-3.336l.037-17.664-8.226 4.78L2.2 15.927l-.044 17.667c-.002 1.225.862 2.723 1.928 3.337.537.311 1.023.339 1.375.135l24.18-14.053c-.352.204-.84.176-1.376-.132z" fill="#ed5d71"/><path d="M3.166 16.596l3.266 1.885.238.138V37.34c-.316-.019-.664-.127-1.03-.338-1.388-.804-2.515-2.753-2.51-4.347z" fill="#e3e7f0"/><path d="M31.403 4.775l-.044 17.667c-.004.97-.347 1.657-.903 1.978L6.276 38.473c.555-.324.898-1.008.903-1.98l.043-17.668z" fill="#ed5d71"/><g><path d="M6.275 18.392L28.975 5.2l-3.108-1.796-22.7 13.193z" fill="#fff"/></g><g><path d="M1.046 15.26l-.044 17.668c-.005 1.956 1.375 4.348 3.078 5.331 1.703.983 3.092.19 3.098-1.765l.044-17.668-1.155-.666-.044 17.667c-.003 1.224-.873 1.72-1.94 1.105-1.065-.615-1.93-2.113-1.926-3.337L2.2 15.928z" fill="#d3374e"/></g><g><path d="M7.222 18.826l24.18-14.052-1.155-.666L6.067 18.16z" fill="#fe91ab"/></g><path d="M31.409 1.877l-5.75 3.342-2.483 4.336 8.227-4.78z" fill="#ed5d71"/><path d="M25.66 5.219l-2.483 4.335-1.154-.666 2.482-4.336z" fill="#d3374e"/><g><path d="M25.66 5.219l5.749-3.34-1.155-.667-5.749 3.34z" fill="#fe91ab"/></g><g><path d="M10.995 20.983L35.175 6.93l-1.154-.666L9.84 20.316z" fill="#ffdd94"/><path d="M37.058 27.936c-1.066-.617-1.93-2.115-1.926-3.337l.038-17.665-8.227 4.78-15.948 9.268-.043 17.667c-.002 1.224.862 2.723 1.928 3.337.536.311 1.023.339 1.374.135l24.18-14.053c-.35.204-.84.176-1.376-.133z" fill="#febb61"/><path d="M11.96 21.651l3.266 1.885.238.138v18.721c-.315-.019-.663-.127-1.03-.338-1.388-.804-2.515-2.753-2.51-4.347z" fill="#e3e7f0"/><path d="M40.197 9.83l-.043 17.667c-.005.97-.348 1.657-.903 1.978L15.07 43.528c.556-.324.899-1.007.903-1.98l.044-17.668z" fill="#febb61"/><g><path d="M15.07 23.447l22.7-13.192-3.109-1.796-22.7 13.192z" fill="#fff"/></g><g><path d="M9.84 20.316l-.043 17.667c-.006 1.956 1.375 4.348 3.078 5.331 1.702.983 3.092.19 3.098-1.766l.043-17.667-1.154-.666-.044 17.667c-.004 1.224-.874 1.72-1.94 1.105-1.066-.615-1.93-2.113-1.927-3.337l.044-17.668z" fill="#efa143"/></g><g><path d="M16.016 23.881L40.196 9.83l-1.154-.666-24.18 14.052z" fill="#ffdd94"/></g><path d="M40.203 6.932l-5.75 3.342-2.482 4.336 8.226-4.78z" fill="#febb61"/><path d="M34.455 10.274l-2.483 4.335-1.155-.666L33.3 9.607z" fill="#efa143"/><g><path d="M34.455 10.274l5.748-3.34-1.154-.668-5.75 3.341z" fill="#ffdd94"/></g></g><g><path d="M19.79 26.037l24.18-14.052-1.154-.666-24.18 14.052z" fill="#7bb1ff"/><path d="M45.853 32.99c-1.066-.616-1.93-2.114-1.926-3.336l.037-17.665-8.226 4.78-15.948 9.267-.044 17.668c-.002 1.224.862 2.723 1.928 3.337.537.31 1.023.339 1.375.135l24.18-14.053c-.351.204-.84.176-1.376-.133z" fill="#5793fb"/><path d="M20.755 26.706l3.266 1.885.238.138V47.45c-.315-.019-.664-.127-1.03-.338-1.388-.804-2.515-2.754-2.51-4.347z" fill="#e3e7f0"/><path d="M48.992 14.885l-.044 17.667c-.004.97-.347 1.657-.903 1.978l-24.18 14.053c.555-.324.899-1.008.903-1.98l.043-17.668z" fill="#5793fb"/><g fill="#e3e7f0"><path d="M41.179 34.52l5.887-3.42s-.003 1.159-.002 1.232l-5.89 3.423zM41.179 32.193l5.887-3.421s-.003 1.16-.002 1.232l-5.89 3.423zM41.179 29.865l5.887-3.42s-.003 1.158-.002 1.231l-5.89 3.424z"/></g><g><path d="M23.865 28.502l22.7-13.193-3.11-1.795-22.7 13.192z" fill="#fff"/></g><g><path d="M18.635 25.37l-.044 17.668c-.005 1.956 1.375 4.348 3.078 5.33 1.703.984 3.093.192 3.098-1.764l.044-17.668-1.155-.666-.044 17.667c-.003 1.224-.873 1.72-1.94 1.105s-1.93-2.113-1.926-3.337l.044-17.668z" fill="#3a53d0"/></g><g><path d="M24.811 28.936l24.18-14.052-1.154-.666-24.18 14.052z" fill="#7bb1ff"/></g><path d="M48.998 11.987l-5.75 3.342-2.482 4.336 8.226-4.78z" fill="#5793fb"/><path d="M43.25 15.329l-2.483 4.335-1.155-.666 2.483-4.336z" fill="#3a53d0"/><g><path d="M43.25 15.329l5.748-3.34-1.155-.668-5.748 3.341z" fill="#7bb1ff"/></g></g></svg>
                    帮助文档
                </div>
            </h3>
            <el-collapse class="u-groups" v-model="activeDocGroup">
                <!-- <el-collapse-item title="发布指南" name="senior">
                    <div class="u-docs">
                        <a v-for="(item, i) in jx3dat_senior" :key="i" class="u-doc" :href="item.link" target="_blank">
                            <i class="el-icon-collection"></i>
                            {{ item.label }}
                        </a>
                    </div>
                </el-collapse-item> -->
                <!-- <el-collapse-item title="版规与要求" name="rule" class="m-tool-rule">
                    <div class="u-content" v-html="rules"></div>
                </el-collapse-item> -->
                <el-collapse-item title="入门指南" name="newbie">
                    <div class="u-docs">
                        <a v-for="(item, i) in jx3dat_newbie" :key="i" class="u-doc" :href="item.link" target="_blank">
                            <i class="el-icon-collection"></i>
                            {{ item.label }}
                        </a>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="API文档" name="api" class="m-tool-api">
                    <div class="u-list" v-if="apis && apis.length">
                        <a
                            class="u-item"
                            v-for="(item, i) in apis"
                            :href="item.link"
                            target="_blank"
                            :style="highLight(item.color)"
                            :key="i"
                        >
                            <i :class="item.icon"></i> {{ item.label }}
                        </a>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="热门搜索" name="tags" class="m-tool-rule">
                    <div class="m-nav-tags" v-if="tags && tags.length">
                        <!-- <h5 class="u-title"><i class="el-icon-collection-tag"></i> 热门搜索</h5> -->
                        <div class="u-list">
                            <a :href="item.link" target="_blank" v-for="(item, i) in tags" :key="i">{{ item.label }}</a>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <!-- <Github_REPO REPO="fb" coder="8"></Github_REPO> -->
    </div>
</template>

<script>
import minirank from "./minirank.vue";
import { getMenuGroups, getMenuGroup } from "@/service/helper.js";
export default {
    name: "list_side",
    props: [],
    data: function () {
        return {
            activeDocGroup: [],
            jx3dat_newbie: [],
            jx3dat_senior: [],

            qq: "608303480",

            tags: [],
            rules: "",
            apis: [],
        };
    },
    methods: {
        onQQClick() {
            navigator.clipboard.writeText(this.qq).then(() => {
                this.$notify({
                    title: "复制成功",
                    message: "内容：" + this.qq,
                    type: "success",
                });
            });
        },
        loadRules: function () {
            try {
                const data = sessionStorage.getItem("tool_rule");

                if (data) {
                    this.rules = data;
                } else {
                    getBread("tool_rule").then((res) => {
                        this.rules = res.data.data.html;

                        sessionStorage.setItem("tool_rule", this.rules);
                    });
                }
            } catch (e) {
                this.rules = "";
            }
        },
        loadApis: function () {
            try {
                const data = sessionStorage.getItem("tool_api");

                if (data) {
                    this.apis = JSON.parse(data);
                } else {
                    getMenuGroup("tool_api").then((res) => {
                        this.apis = res.data.data.menus || [];

                        sessionStorage.setItem("tool_api", JSON.stringify(this.apis));
                    });
                }
            } catch (e) {
                this.apis = [];
            }
        },
        loadTags() {
            try {
                const data = sessionStorage.getItem("tool_links");

                if (data) {
                    this.tags = JSON.parse(data);
                } else {
                    getMenuGroup("tool_links").then((res) => {
                        this.tags = res.data.data?.menus || [];

                        sessionStorage.setItem("tool_links", JSON.stringify(this.tags));
                    });
                }
            } catch (e) {
                this.tags = [];
            }
        },
        loadMenu: function () {
            const key = ["jx3dat_newbie", "jx3dat_senior"].join(",");
            getMenuGroups(key).then((res) => {
                let data = res.data.data.reduce((obj, item) => {
                    obj[item.name] = item;
                    return obj;
                }, {});
                for (let key in data) {
                    this[key] = data[key]["menus"];
                }
            });
        },
        highLight: function (val) {
            if (val) {
                return "color:" + val + ";font-weight:bold;";
            }
            return "";
        },
    },
    mounted: function () {
        this.loadTags();
        // this.loadRules();
        this.loadApis();
        this.loadMenu();
    },
    components: {
        minirank,
    },
};
</script>

<style lang="less">
.m-side-title {
    margin: 20px 0 10px 0;
}

.m-extend-list {
    .u-link {
        .pointer;
    }

    .c-sidebar-right-msg {
        margin-left: 0;
        margin-right: 0;
    }
}

.m-side-links {
    .u-title {
        .flex;
        align-items: center;
        gap: 10px;
        .fz(18px);
    }

    .u-icon {
        .size(20px);
    }

    .u-groups {
        padding: 0 5px;
    }
    .u-doc {
        .nobreak;
        .flex;
        align-items: center;
        .fz(12px, 34px);
        // border-bottom: 1px solid #eee;
        i {
            .fz(16px);
            color: #666;
            .mr(5px);
        }
        &:last-child {
            border-bottom: none;
        }
        &:hover {
            .bold;
            color: @pink;
        }
    }
}

.m-tool-api {
    .u-item {
        display: block;
        padding: 0 5px;
        font-size: 12px;
        line-height: 3;
        text-align: left;
        border-bottom: 1px dashed #eee;
        cursor: pointer;
        height: 32px;

        &:hover {
            color: @pink;
            font-weight: bold;
        }
    }
}

@media screen and (max-width: @phone) {
    .m-side-rank,
    .m-side-links {
        .none;
    }
}

.c-sidebar-right-list {
    .u-item {
        i {
            .mr(5px);
        }
    }
}

.c-sidebar-right-title {
    font-weight: bold;
}
</style>
